/**
 * The initial value of Symbol.hasInstance is the well-known symbol @@hasInstance
 * https://tc39.es/ecma262/#sec-symbol.hasinstance
 */
export const symbolHasInstance = () => Symbol("Symbol.hasInstance");
